import gql from 'graphql-tag';

export const PricingCategories = gql`
  query pricingCategories {
    pricingCategories(slice: { limit: 999 }) {
      total
      records {
        id
        name
        type
        display_order
        tag_templates(slice: { limit: 999 }) {
          total
          records {
            id
            tag_template {
              ... on UniformTagTemplate {
                id
                name
                gender
              }
            }
          }
        }
      }
    }
  }
`;

export const PricingCategory = gql`
  query pricingCategory($id: RecordID) {
    pricingCategories(pricing_category_id: $id) {
      total
      records {
        id
        name
        type
        display_order
        tag_templates(slice: { limit: 999 }) {
          total
          records {
            id
            tag_template {
              ... on UniformTagTemplate {
                id
                name
                gender
              }
            }
          }
        }
        print_assets(slice: { limit: 999 }) {
          total
          records {
            id
            print_asset {
              id
              name
              type
              jersey_colors(slice: { limit: 999 }) {
                records {
                  id
                  jersey_color
                }
              }
              asset_image {
                id
                url
                width
                height
              }
            }
          }
        }
      }
    }
  }
`;

export const PricingCategoriesForPrintAssets = gql`
  query pricingCategoriesForPrintAssets($print_asset_type: PrintAssetTypeEnum) {
    pricingCategories(slice: { limit: 999 }) {
      total
      records {
        id
        name
        type
        display_order
        print_assets(
          slice: { limit: 999 }
          print_asset_type: $print_asset_type
        ) {
          total
          records {
            id
            print_asset {
              id
              name
              type
              jersey_colors(slice: { limit: 999 }) {
                records {
                  id
                  jersey_color
                }
              }
              asset_image {
                id
                url
                width
                height
              }
            }
          }
        }
      }
    }
  }
`;
